import type { MacroImageFailure } from "@redotech/admin-sdk/rpc/schema/support/macro-import-result";
import { RedoButton } from "@redotech/arbiter/buttons/redo-button";
import { Flex } from "@redotech/arbiter/flex";
import { Text } from "@redotech/arbiter/text";
import { memo } from "react";

interface MacroImageFailuresProps {
  failures: readonly MacroImageFailure[];
  retrying: boolean;
  onRetry: () => void;
}

export const MacroImageFailures = memo(function MacroImageFailures({
  failures,
  retrying,
  onRetry,
}: MacroImageFailuresProps) {
  if (failures.length === 0) {
    return null;
  }
  return (
    <Flex dir="column" gap="sm">
      <Text fontSize="sm" fontWeight="semibold">
        {failures.length} images couldn't be copied
      </Text>
      <Text fontSize="sm" textColor="secondary">
        These macros still link to the image on the original helpdesk, which may
        stop working. Retry once the cause is fixed, or re-add the image in the
        macro editor.
      </Text>
      <Text fontSize="sm" textColor="secondary">
        {failures.map((failure, index) => (
          <li key={`${failure.macroId}-${failure.imageHost}-${index}`}>
            <strong>{failure.macroName}</strong> ({failure.imageHost}):{" "}
            {failure.reason}
          </li>
        ))}
      </Text>
      <div>
        <RedoButton
          disabled={retrying}
          hierarchy="secondary"
          onClick={onRetry}
          pending={retrying}
          size="md"
          text="Retry images"
          theme="normal"
        />
      </div>
    </Flex>
  );
});
